<template>
  <div class="nt-page container-fluid" :style="bg">
    <div class="row justify-content-center">
      <div :class="col">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'nt-page',
  props: {
    background: {
      type: String,
      default: 'white',
    },
    colSize: {
      type: Number,
      default: 12,
    },
  },
  data() {
    return {
      bg: `background-color: ${this.$props.background}`,
      col: `col-lg-${this.$props.colSize}`,
    }
  },
  methods: {
    addClass() {
      const container = document.querySelector('.nt-page')
      container.classList.add('page-content-reset')
    },
    checkParam() {
      const url = window.location.href
      if (url.includes('?success=true')) {
        this.addClass()
      }
    },
  },
  mounted() {
    this.checkParam()
  },
}
</script>

<style lang="scss" scoped>
  .nt-page {
    width: 100%;
    display: inline-block;

    &.container-fluid {
      padding-left: 0;
      padding-right: 0;
    }

    .row {
      margin-left: auto;
      margin-right: auto;
    }
  }

  .page-content-reset {
    .vt-video__poster {
      z-index: auto;
    }
    .row {
      z-index: auto;
    }
    .col {
      z-index: auto;
    }
  }
</style>